module.exports = __webpack_public_path__ + "img/icon-christmas-6.decf25cd.svg";